import {PageView} from "./PageView.js";
import {EmailAuthLayout} from "../components/layout/EmailAuthLayout.js";
import {Header} from "../components/Header.js";
import {EmailAuthInput} from "../components/input/EmailAuthInput.js";
import {getEmail, isGuestUser} from "../store.js";
import {checkAuthNum, sendAuthNumberToEmail} from "../../../apiCall/signup/index.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {InputErrorHandler} from "../util/input-error-handler/index.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";


export class EmailAuthView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        this.$props.EmailAuthLayout = new EmailAuthLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.checkAuthNumber.bind(this)
            }
        });
    }

    renderComponents() {
        const $section = $(`#${this.getSectionId()}`);
        new Header($section.find(".js-section-header"), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });

        this.$props.EmailAuthIput = new EmailAuthInput($section.find(".js-contents-main"), {
            isAfter: true,
            $posTarget: $("#subTxt"),
            inputId: this.getInputId(),
            isLast: true,
            sendEmail: this.sendAuthNumber2Email.bind(this),
            submit: this.checkAuthNumber.bind(this),
        })
    }

    mounted() {
        this.sendAuthNumber2Email();
    }

    getInputId() {
        return `authNumberInput`
    }

    async sendAuthNumber2Email() {
        const email = getEmail();
        if (Mutil.empty(email)) {
            Mutil.mlog("이메일 정보가 없어서 인증 번호를 이메일로 보낼 수 없습니다.");
            return;
        }


        const authInfo = await sendAuthNumberToEmail({
            USER_ID: email,
            AUTH_ID: email,
            AUTH_TYPE: 'E', ...this.getDeviceInfo()
        });
        this.$props.EmailAuthIput.startCounter(authInfo.AUTH_TIME_MM)

        this.fillAuthNumByDevelop(authInfo);
        this.$props.EmailAuthLayout.showAuthInfoText();
    }

    getDeviceInfo() {
        const isEmptyClientIp = () => {
            return (isGuestUser() || ServerChecker.isKtWorks || ServerChecker.isKtFlow || (ServerChecker.isKtWorks && KtWorksConfig.isLoginPage));
        }
        const ip = isEmptyClientIp() ? "" : window._CLIENT_IP;
        const Often = Mutil.requireIIFE("Often");
        return Often.getDeviceJson(ip);
    }

    fillAuthNumByDevelop({AUTH_NO = ""}) {
        if (!Mutil.isServerOn("DEV_TEST") || Mutil.empty(AUTH_NO)) {
            return;
        }
        Mutil.toast("success", "테스트 서버이면서 XXtestXX@yopmail.com 도메인일 경우 2초 뒤에 자동으로 인증번호가 채워집니다.");
        this.$props.EmailAuthIput.addAuthNumber(AUTH_NO)
    }

    async checkAuthNumber(remainMinute = "3") {
        const $authNumberInput = $(`#${this.getInputId()}`)
        const email = getEmail();
        if (Mutil.empty(email)) {
            Mutil.mlog("이메일 정보가 없어서 인증 번호를 체크할 수 없습니다.");
            return;
        }

        if (!this.$props.EmailAuthIput.inputValidate()) {
            Mutil.mlog("인증 번호가 유효하지 않아서 인증 번호를 체크할 수 없습니다.");
            return;
        }

        const result = await checkAuthNum({
            USER_ID: email,
            AUTH_NO: $authNumberInput.val(),
            AUTH_TIME_MM: remainMinute,
            ...this.getDeviceInfo()
        });

        const $authNumberInputLayer = $authNumberInput.parent();
        if ("9203" === Often.null2Void(result.RSLT_CD)) {
            Mutil.toast("error", result?.ERR_MSG);
            return;
        }

        if ("0000" !== Often.null2Void(result.RSLT_CD)) {
            InputErrorHandler.activeErrorModeAboutInput($authNumberInputLayer, i18next.t(main.alert.verificationNotMatch));
            return;
        }

        SignUpViewChanger.loadProfileView();
    }


}